import { render, staticRenderFns } from "./MappedData.vue?vue&type=template&id=353f5c8c&scoped=true"
import script from "./MappedData.vue?vue&type=script&lang=js"
export * from "./MappedData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353f5c8c",
  null
  
)

export default component.exports